import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },

  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}/dashboards`,
    component: React.lazy(() => import("views/app-views/dashboards/Dashboard")),
  },
  {
    key: "dashboard.innerdashboards",
    path: `${APP_PREFIX_PATH}/dashboard/dashboard-school`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/innerdashboards/SchoolDashboard")
    ),
  },
  {
    key: "dashboard.innerdashboards",
    path: `${APP_PREFIX_PATH}/dashboard/dashboard-orders`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/innerdashboards/OrdersDashboard")
    ),
  },
  {
    key: "dashboard.innerdashboards",
    path: `${APP_PREFIX_PATH}/dashboard/dashboard-total-students`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/innerdashboards/StudentDashboard")
    ),
  },
  {
    key: "dashboard.innerdashboards",
    path: `${APP_PREFIX_PATH}/dashboard/dashboard-order-completed`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/innerdashboards/CompletedOrders")
    ),
  },
  {
    key: "dashboard.innerdashboards",
    path: `${APP_PREFIX_PATH}/dashboard/dashboard-order-pending`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/innerdashboards/PendingOrders")
    ),
  },
  {
    key: "dashboard.innerdashboards",
    path: `${APP_PREFIX_PATH}/dashboard/dashboard-order-cancelled`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/innerdashboards/CanceledOrders")
    ),
  },
  {
    key: "orders.open",
    path: `${APP_PREFIX_PATH}/orders/Open`,
    component: React.lazy(() => import("views/app-views/orders/open/list")),
  },
  {
    key: "orders.open.details",
    path: `${APP_PREFIX_PATH}/orders/:id`,
    component: React.lazy(() => import("views/app-views/orders/open/details")),
  },
  {
    key: "orders.closed",
    path: `${APP_PREFIX_PATH}/orders/Closed`,
    component: React.lazy(() => import("views/app-views/orders/closed")),
  },
  {
    key: "pose-management.poses",
    path: `${APP_PREFIX_PATH}/pose-management/poses/list`,
    component: React.lazy(() =>
      import("views/app-views/pose-management/poses/list-pose/index")
    ),
  },
  {
    key: "pose-management.poses.add",
    path: `${APP_PREFIX_PATH}/pose-management/poses/add`,
    component: React.lazy(() =>
      import("views/app-views/pose-management/poses/add-pose/index")
    ),
  },
  {
    key: "pose-management.poses.edit",
    path: `${APP_PREFIX_PATH}/pose-management/poses/edit/:pose_id`,
    component: React.lazy(() =>
      import("views/app-views/pose-management/poses/edit-pose/index")
    ),
  },
  {
    key: "pose-management.group-photos.list",
    path: `${APP_PREFIX_PATH}/pose-management/group-photos/list`,
    component: React.lazy(() =>
      import("views/app-views/pose-management/group-photos/list-photo/index")
    ),
  },
  {
    key: "pose-management.pose.package.list",
    path: `${APP_PREFIX_PATH}/pose-management/packages/:pose_id`,
    component: React.lazy(() =>
      import("views/app-views/pose-management/poses/packages")
    ),
  },
  {
    key: "pose-management.group_photo.package.list",
    path: `${APP_PREFIX_PATH}/grop-photo/packages/:group_photo_id`,
    component: React.lazy(() =>
      import("views/app-views/pose-management/group-photos/packages")
    ),
  },
  {
    key: "pose-management.group-photos.add",
    path: `${APP_PREFIX_PATH}/pose-management/group-photos/add`,
    component: React.lazy(() =>
      import("views/app-views/pose-management/group-photos/add-photo/index")
    ),
  },
  {
    key: "pose-management.group-photos.edit",
    path: `${APP_PREFIX_PATH}/pose-management/group-photos/edit/:photo_id`,
    component: React.lazy(() =>
      import("views/app-views/pose-management/group-photos/edit-photo/index")
    ),
  },
  {
    key: "pose-management.group-photos-type.add",
    path: `${APP_PREFIX_PATH}/pose-management/group-photos/type/add`,
    component: React.lazy(() =>
      import(
        "views/app-views/pose-management/group-photos/add-photo-type/index"
      )
    ),
  },
  {
    key: "package-management.list",
    path: `${APP_PREFIX_PATH}/package-management/list`,
    component: React.lazy(() =>
      import("views/app-views/package-management/list-package/index")
    ),
  },
  {
    key: "package-management.add",
    path: `${APP_PREFIX_PATH}/package-management/add`,
    component: React.lazy(() =>
      import("views/app-views/package-management/add-package/index")
    ),
  },
  {
    key: "package-management.edit",
    path: `${APP_PREFIX_PATH}/package-management/edit/:package_id`,
    component: React.lazy(() =>
      import("views/app-views/package-management/edit-package/index")
    ),
  },
  {
    key: "school-management.academic-year",
    path: `${APP_PREFIX_PATH}/school-management/academic-year`,
    component: React.lazy(() =>
      import("views/app-views/school-management/academic-year/AcademicYear")
    ),
  },
  {
    key: "school-management.academic-year",
    path: `${APP_PREFIX_PATH}/school-management/academiyearform`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/academic-year/components/AddAcademicYearForm"
      )
    ),
  },
  {
    key: "school-management.academic-year",
    path: `${APP_PREFIX_PATH}/school-management/academiyearform-edit/:id`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/academic-year/components/AddAcademicYearForm"
      )
    ),
  },
  {
    key: "school-management.school",
    path: `${APP_PREFIX_PATH}/school-management/school`,
    component: React.lazy(() =>
      import("views/app-views/school-management/school/School")
    ),
  },
  {
    key: "school-management.school",
    path: `${APP_PREFIX_PATH}/school-management/addschool`,
    component: React.lazy(() =>
      import("views/app-views/school-management/school/add")
    ),
  },
  {
    key: "school-management.school",
    path: `${APP_PREFIX_PATH}/school-management/addpromo-code/:id`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/school/components/PromoCodeManager.jsx"
      )
    ),
  },
  {
    key: "school-management.school",
    path: `${APP_PREFIX_PATH}/school-management/editschool/:school_id`,
    component: React.lazy(() =>
      import("views/app-views/school-management/school/edit")
    ),
  },
  {
    key: "school-management.school",
    path: `${APP_PREFIX_PATH}/school-management/setpackage/:id`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/school/components/SetPackagePrice"
      )
    ),
  },
  {
    key: "school-management.school",
    path: `${APP_PREFIX_PATH}/school-management/managepackage/:id`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/school/components/ManagePackages"
      )
    ),
  },
  {
    key: "school-management.school",
    path: `${APP_PREFIX_PATH}/school-management/invitestudent/:id`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/school/components/StudentInvitation "
      )
    ),
  },
  {
    key: "school-management.school",
    path: `${APP_PREFIX_PATH}/school-management/addgroup`,
    component: React.lazy(() =>
      import("views/app-views/school-management/school/components/AddGroup")
    ),
  },
  {
    key: "school-management.division",
    path: `${APP_PREFIX_PATH}/school-management/class-division`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/class-division/ClassAndDivision"
      )
    ),
  },
  {
    key: "school-management.division",
    path: `${APP_PREFIX_PATH}/school-management/class-division/addclass`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/class-division/components/AddClassAndDivision"
      )
    ),
  },
  {
    key: "school-management.division",
    path: `${APP_PREFIX_PATH}/school-management/class-division/editclass/:id`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/class-division/components/AddClassAndDivision"
      )
    ),
  },
  {
    key: "school-management.student",
    path: `${APP_PREFIX_PATH}/school-management/student`,
    component: React.lazy(() =>
      import("views/app-views/school-management/student/Student")
    ),
  },
  {
    key: "school-management.student",
    path: `${APP_PREFIX_PATH}/school-management/student/addstudent`,
    component: React.lazy(() =>
      import("views/app-views/school-management/student/add-pose")
    ),
  },
  {
    key: "school-management.student",
    path: `${APP_PREFIX_PATH}/school-management/student/editstudent/:id/:academic_year_id`,
    component: React.lazy(() =>
      import("views/app-views/school-management/student/edit-pose")
    ),
  },
  {
    key: "school-management.student",
    path: `${APP_PREFIX_PATH}/school-management/student/studentdetails/:id/:academic_year_id`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/student/components/StudentDetails"
      )
    ),
  },
  {
    key: "school-management.student",
    path: `${APP_PREFIX_PATH}/school-management/student/import-pose`,
    component: React.lazy(() =>
      import(
        "views/app-views/school-management/student/components/ImportStudentsPoseExcel"
      )
    ),
  },
  {
    key: "school-management.parents",
    path: `${APP_PREFIX_PATH}/school-management/parents`,
    component: React.lazy(() =>
      import("views/app-views/school-management/parents/list/index")
    ),
  },
  {
    key: "school-management.parents.edit",
    path: `${APP_PREFIX_PATH}/school-management/parents/edit/:parent_id`,
    component: React.lazy(() =>
      import("views/app-views/school-management/parents/edit/index")
    ),
  },
  {
    key: "school-management.parents.view-students",
    path: `${APP_PREFIX_PATH}/school-management/parents/my-students/:parent_id`,
    component: React.lazy(() =>
      import("views/app-views/school-management/parents/view-students/index")
    ),
  },
  {
    key: "location-delivery.delivery-location",
    path: `${APP_PREFIX_PATH}/location-delivery/delivery-location`,
    component: React.lazy(() =>
      import("views/app-views/location-delivery/delivery-location/list")
    ),
  },
  {
    key: "location-delivery.delivery-location.add",
    path: `${APP_PREFIX_PATH}/location-delivery/delivery-location/add`,
    component: React.lazy(() =>
      import("views/app-views/location-delivery/delivery-location/add")
    ),
  },
  {
    key: "location-delivery.delivery-location.edit",
    path: `${APP_PREFIX_PATH}/location-delivery/delivery-location/:location_id`,
    component: React.lazy(() =>
      import("views/app-views/location-delivery/delivery-location/edit")
    ),
  },
  {
    key: "location-delivery.country-management",
    path: `${APP_PREFIX_PATH}/location-delivery/country`,
    component: React.lazy(() =>
      import(
        "views/app-views/location-delivery/country-management/list-country"
      )
    ),
  },
  {
    key: "location-delivery.country-management",
    path: `${APP_PREFIX_PATH}/location-delivery/country/add`,
    component: React.lazy(() =>
      import("views/app-views/location-delivery/country-management/add-country")
    ),
  },
  {
    key: "location-delivery.country-management",
    path: `${APP_PREFIX_PATH}/location-delivery/country/edit/:id`,
    component: React.lazy(() =>
      import(
        "views/app-views/location-delivery/country-management/edit-country"
      )
    ),
  },
  {
    key: "settings.cms",
    path: `${APP_PREFIX_PATH}/settings/cms`,
    component: React.lazy(() => import("views/app-views/settings/cms/Cms")),
  },
  {
    key: "settings.cms.edit",
    path: `${APP_PREFIX_PATH}/settings/cms/edit/:type`,
    component: React.lazy(() =>
      import("views/app-views/settings/cms/Cms-edit")
    ),
  },
  {
    key: "settings.maintenance",
    path: `${APP_PREFIX_PATH}/settings/maintenance`,
    component: React.lazy(() =>
      import("views/app-views/settings/maintenance")
    ),
  },
  {
    key: "user-management-list",
    path: `${APP_PREFIX_PATH}/user-management/list`,
    component: React.lazy(() =>
      import("views/app-views/user-management/list-user/index")
    ),
  },
  {
    key: "user-management-add",
    path: `${APP_PREFIX_PATH}/user-management/add`,
    component: React.lazy(() =>
      import("views/app-views/user-management/add-user/index")
    ),
  },
  {
    key: "user-management-edit",
    path: `${APP_PREFIX_PATH}/user-management/edit/:user_id`,
    component: React.lazy(() =>
      import("views/app-views/user-management/edit-user/index")
    ),
  },

  //photographer-routes
  // {
  //   key: "photographer-profile",
  //   path: `${APP_PREFIX_PATH}/profile/:id`,
  //   component: React.lazy(() =>
  //     import("views/photographer-views/profile")
  //   ),
  // },
];

export const photographerRoutes = [
  {
    key: "qr-code",
    path: `${APP_PREFIX_PATH}/qr-code`,
    component: React.lazy(() =>
      import("views/photographer-views/qr-code-scanner")
    ),
  },
  {
    key: "photographer-profile",
    path: `${APP_PREFIX_PATH}/profile/:id`,
    component: React.lazy(() => import("views/photographer-views/profile")),
  },
  {
    key: "photographer-poses",
    path: `${APP_PREFIX_PATH}/poses/:id`,
    component: React.lazy(() => import("views/photographer-views/photo-list")),
  },
  {
    key: "terms-condition",
    path: `${AUTH_PREFIX_PATH}/terms-condition`,
    component: React.lazy(() =>
      import("views/photographer-views/terms-condition")
    ),
  },
  {
    key: "privacy-policy",
    path: `${AUTH_PREFIX_PATH}/privacy-policy`,
    component: React.lazy(() =>
      import("views/photographer-views/privacy-policy")
    ),
  },
];
